import { useTheme } from "@mui/material";

export function useCADImageBackgroundColor(): string {

    const theme = useTheme();
    return theme.palette.mode === "dark" ? "white": "transparent";

}